/* API ROUTES - REST */
export const ELIGIBLE_PEOPLE_DOWNLOAD_PATH = '/api/eligible-people'
export const REPORT_DOWNLOAD_PATH = `/api/reports`
export const REPORT_SUMMARY_DOWNLOAD_PATH = `/api/reportSummary`
export const ADMIN_REPORT_DOWNLOAD_PATH = '/api/admin/reports'
